/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDeleteAccountStyles = makeStyles(theme => ({
  title: {
    marginBottom: '20px',
  },
  warning: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    borderRadius: '6px',
    marginBottom: '20px',
  },
  modalText: {
    padding: '40px 20px 15px',
    textAlign: 'center',
  },
}));
